import _ from 'lodash'
import config from '../../config'
import fetch from '../../lib/wrappedFetch'

class CustomersService {
  _mapCustomer = (customer) => {
    return {
      ...customer.details,
      ...(_.omit(customer, 'details'))
    }
  }
  searchCustomers = (params) => {
    return fetch(config.config.endpointUrls.searchCustomers(), {
      method: 'POST',
      body: { ...params }
    })
      .then((results) => {
        const mappedCustomers = _.chain(results.results)
          .map(this._mapCustomer)
          .value()
        return {
          ...results,
          results: mappedCustomers
        }
      })
  }
  fetchCustomerDetails = (params) => {
    return fetch(config.config.endpointUrls.fetchCustomerDetails(params), {
      method: 'GET'
    })
      .then(this._mapCustomer)
  }
  updateCustomerDetails = ({ id, ...fields }) => {
    return fetch(config.config.endpointUrls.updateCustomerDetails({ id }), {
      method: 'PATCH',
      body: fields
    })
      .then(this._mapCustomer)
  }
  createCustomer = (fields) => {
    return fetch(config.config.endpointUrls.createCustomer(), {
      method: 'POST',
      body: fields
    })
      .then(this._mapCustomer)
  }

  validateCustomerToken = params => {
    return fetch(config.config.endpointUrls.validateCustomerToken(params), {
      method: 'POST'
    })
  }

  unsubscribe = params => {
    return fetch(config.config.endpointUrls.unsubscribe(params), {
      method: 'POST',
      body: _.pick(params, ['token', 'updates'])
    })
  }

  anonymiseCustomer = ({ customerId }) => {
    return fetch(config.config.endpointUrls.anonymiseCustomer({ customerId }), {
      method: 'POST'
    })
  }

  fetchCustomerStoreMarketingForId = (customerId, options) => {
    return fetch(config.config.endpointUrls.fetchCustomerStoreMarketing({ customerId, ...options }), {
      method: 'GET'
    })
  }

  setCustomerStoreMarketingForId = (customerId, storeIds) => {
    return fetch(config.config.endpointUrls.setCustomerStoreMarketing({ customerId, storeIds }), {
      method: 'PUT',
      body: {
        storeIds
      }
    })
  }
}

export default new CustomersService()



// WEBPACK FOOTER //
// ../src/services/customersService/customersService.js